import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { addCompany, updateCompany } from "../../../services/userMasterUser";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";

export default function CompanyCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [input, setInput] = useState({
    personalName: state?.personalName || "",
    designation: state?.designation || "",
    name: state?.name || "",
    mobile: state?.mobile || "",
    emailId: state?.emailId || "",
    companyCinNo: state?.companyCinNo || "",
    location: state?.location || "",
    sector: state?.sector || "",
    subSector: state?.subSector || "",
    industry: state?.industry || "",
    revenue: state?.revenue || "",
    state: state?.state || "",
    status: state?.status || "ACTIVE",
  });

  useEffect(() => {
    if (state) {
      setInput(prevState => ({
        ...prevState,
        status: state?.status,
      }));
    }
  }, [state]);

  const [errors, setErrors] = useState({
    personalName : "",
    designation : "",
    name : "",
    mobile : "",
    emailId : "",
    companyCinNo : "",
    location : "",
    sector : "",
    subSector : "",
    industry : "",
    revenue : "",
    state : "",
    status: "",
  });

  const [statusData, setStatusData] = useState([
    { label: "ACTIVE", value: "ACTIVE" },
    { label: "INACTIVE", value: "INACTIVE" }
  ]);

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;
    
    if (!(input.name)) {
      newErrors.name = "Please Enter Name";
      isValid = false;
    } else {
      newErrors.name = "";
    }

    if (!(input.mobile)) {
      newErrors.mobile = "Please Enter Mobile";
      isValid = false;
    } else {
      newErrors.mobile = "";
    }

    if (!(input.state)) {
      newErrors.state = "Please Enter State";
      isValid = false;
    } else {
      newErrors.state = "";
    }
    
    
    if (!(input.personalName)) {
      newErrors.personalName = "Please Enter Personal Name";
      isValid = false;
    } else {
      newErrors.personalName = "";
    }
    
    if (!(input.designation)) {
      newErrors.designation = "Please Enter Designation";
      isValid = false;
    } else {
      newErrors.designation = "";
    }
    
    if (!(input.emailId)) {
      newErrors.emailId = "Please Enter Email Id";
      isValid = false;
    } else {
      newErrors.emailId = "";
    }
    
    if (!(input.companyCinNo)) {
      newErrors.companyCinNo = "Please Enter Company Cin No";
      isValid = false;
    } else {
      newErrors.companyCinNo = "";
    }
    
    if (!(input.location)) {
      newErrors.location = "Please Enter Location";
      isValid = false;
    } else {
      newErrors.location = "";
    }
    
    if (!(input.sector)) {
      newErrors.sector = "Please Enter Sector";
      isValid = false;
    } else {
      newErrors.sector = "";
    }
    
    if (!(input.subSector)) {
      newErrors.subSector = "Please Enter Sub Sector";
      isValid = false;
    } else {
      newErrors.subSector = "";
    }
    
    if (!(input.industry)) {
      newErrors.industry = "Please Enter Industry";
      isValid = false;
    } else {
      newErrors.industry = "";
    }
    
    if (!(input.revenue)) {
      newErrors.revenue = "Please Enter Revenue";
      isValid = false;
    } else {
      newErrors.revenue = "";
    }
    
 
    if (input.status === "") {
      newErrors.status = "Please Choose Status";
      isValid = false;
    } else {
      newErrors.status = "";
    }

    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (state) {
        let data = {
          id: state?.id,
          name: input.name,
          mobile: input.mobile,
          personalName: input.personalName,
          state: input.state,
          designation: input.designation,
          emailId: input.emailId,
          companyCinNo: input.companyCinNo,
          location: input.location,
          sector: input.sector,
          subSector: input.subSector,
          industry: input.industry,
          revenue: input.revenue,
          status: input.status,
        };
        updateCompany(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/company/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      } else {
        let data = {
          name: input.name,
          mobile: input.mobile,
          personalName: input.personalName,
          state: input.state,
          designation: input.designation,
          emailId: input.emailId,
          companyCinNo: input.companyCinNo,
          location: input.location,
          sector: input.sector,
          subSector: input.subSector,
          industry: input.industry,
          revenue: input.revenue,
          status: input.status,
        };
        addCompany(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/company/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      }
    }
  };

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/user-master/company/list")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> Company {state ? "Update" : "Create"}
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Name
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="name"
                        name="name"
                        value={input.name}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            name: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.name}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Mobile
                      </label>
                      <InputText
                        type="tel"
                        style={{ width: "100%" }}
                        id="mobile"
                        name="mobile"
                        value={input.mobile}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            mobile: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.mobile}</div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Personal Name
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="personalName"
                        name="personalName"
                        value={input.personalName}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            personalName: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.personalName}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        State
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="state"
                        name="state"
                        value={input.state}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            state: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.state}</div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Designation
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="designation"
                        name="designation"
                        value={input.designation}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            designation: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.designation}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Email Id
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="emailId"
                        name="emailId"
                        value={input.emailId}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            emailId: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.emailId}</div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Company Cin No
                      </label>
                      <InputText
                        type="number"
                        style={{ width: "100%" }}
                        id="companyCinNo"
                        name="companyCinNo"
                        value={input.companyCinNo}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            companyCinNo: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.companyCinNo}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Location
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="location"
                        name="location"
                        value={input.location}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            location: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.location}</div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Sector
                      </label>
                      <InputText
                        type="sector"
                        style={{ width: "100%" }}
                        id="sector"
                        name="sector"
                        value={input.sector}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            sector: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.sector}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Sub Sector
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="subSector"
                        name="subSector"
                        value={input.subSector}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            subSector: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.subSector}</div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Industry
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="industry"
                        name="industry"
                        value={input.industry}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            industry: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.industry}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Revenue
                      </label>
                      <InputText
                        type="number"
                        style={{ width: "100%" }}
                        id="revenue"
                        name="revenue"
                        value={input.revenue}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            revenue: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.revenue}</div>
                    </div>
                  </div>
                   
                  
                  {state?.id && <div className="row mb-3">
                    <div className="col-md-12">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={statusData}
                        value={input.status}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            status: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.status}</div>
                    </div>
                  </div>}
                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-blue">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
